import { createFileRoute } from "@tanstack/react-router";

import { EmailConnectPage } from "../components/settings/EmailConnectPage";

export const Route = createFileRoute("/settings/email-connect")({
  component: EmailConnectPage,
});
